import { ContextFormFieldCheckbox } from '@bambi/component-library/src/components/forms/context/ContextFormFieldCheckbox';

import { SettingsRowHeader } from './components/SettingsRowHeader';

export default function PricingSettings() {
  return (
    <div className="grid grid-cols-1 gap-x-8 gap-y-4 border-b border-gray-900/10 py-5 md:grid-cols-4">
      <SettingsRowHeader
        title="Pricing Settings"
        description="Organization defaults for pricing."
      />

      <div className="grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-4 md:col-span-3">
        <div className="flex items-center">
          <ContextFormFieldCheckbox
            label="Restrict pricing display"
            fieldPath="restrict_pricing_display"
            helperText={{
              text:
                'Checking this box means that only "Dispatcher" users ' +
                'will not see the green trip price sums on the ' +
                'Dispatch calendar',
              presentation: {
                type: 'tooltip',
              },
            }}
          />
        </div>
        <div className="flex items-center">
          <ContextFormFieldCheckbox
            label="Include canceled trips in revenue"
            fieldPath="include_canceled_trips_in_revenue"
            helperText={{
              text:
                'Checking this box means that canceled trips will be ' +
                'included in revenue calculations shown on the dispatch ' +
                'calendar, reports, and daily digest emails',
              presentation: {
                type: 'tooltip',
              },
            }}
          />
        </div>
      </div>
    </div>
  );
}
